export default __webpack_public_path__ + "static/media/group_5063-phone.c33c5c97.png";